const REVERT_HINTS = [
  {
    test: /Unsupported token/i,
    msg: "链上未开启该支付代币，发行/认购请使用 AAPLB（或联系管理员开启 USDT/BNB）",
  },
  {
    test: /initPrice can not be zero|initPrice/i,
    msg: "单价不能为 0，请填写有效价格",
  },
  {
    test: /Token URI cannot be empty|tokenUri/i,
    msg: "NFT 元数据链接为空，请重新上传封面并提交",
  },
  {
    test: /launchAmount can not be zero|Invalid quantity/i,
    msg: "发行数量无效，请填写大于 0 的整数",
  },
  {
    test: /insufficient funds|Insufficient BNB|not enough funds/i,
    msg: "BNB 余额不足，无法支付 gas 或链上转账",
  },
  {
    test: /user denied|User rejected|rejected the request|ACTION_REJECTED|cancelled/i,
    msg: "已取消钱包操作",
  },
  {
    test: /Wrong network|chainId|network/i,
    msg: "请切换到 BSC 主网（chainId 56）",
  },
  {
    test: /Parent not crowdFunding|Cannot bind yourself|Initial parent cannot/i,
    msg: "推荐关系不符合合约规则，请检查上级地址",
  },
  {
    test: /Exceeds remaining supply|Crowdfunding was closed|sold out/i,
    msg: "剩余可认购数量不足或募集已结束",
  },
  {
    test: /allowance|approve|ERC20/i,
    msg: "代币授权不足，请重新确认授权后再试",
  },
];

function collectErrorText(err, depth = 0, out = []) {
  if (!err || depth > 6) return out;
  if (typeof err === "string") {
    out.push(err);
    return out;
  }
  ["message", "reason", "data", "code"].forEach((key) => {
    const val = err[key];
    if (val !== undefined && val !== null && val !== "") {
      out.push(String(val));
    }
  });
  if (err.error) collectErrorText(err.error, depth + 1, out);
  if (err.cause) collectErrorText(err.cause, depth + 1, out);

  const msg = String(err.message || "");
  const jsonStart = msg.indexOf("{");
  if (jsonStart >= 0) {
    try {
      const json = JSON.parse(msg.slice(jsonStart));
      if (json.message) out.push(String(json.message));
      if (json.data) out.push(String(json.data));
    } catch {
      /* ignore */
    }
  }
  return out;
}

function extractSolidityRevertReason(blob) {
  const patterns = [
    /reverted with reason string\s+'([^']+)'/i,
    /reverted with the following reason:\s*['"]?([^'"\n|]+)/i,
    /execution reverted:\s*([^|,\n]+)/i,
    /VM execution error\.?\s*Revert\s*reason:\s*([^|,\n]+)/i,
  ];
  for (const re of patterns) {
    const m = blob.match(re);
    if (m && m[1]) {
      const reason = m[1].trim();
      if (reason && reason !== "0x" && !/^0x0*$/i.test(reason)) {
        return reason;
      }
    }
  }
  return null;
}

/** 将 web3 / 钱包错误转为用户可读中文说明 */
export function formatContractError(err, fallback = "链上交易失败，请稍后重试") {
  const blob = collectErrorText(err).join(" | ");
  if (!blob) return fallback;

  for (const { test, msg } of REVERT_HINTS) {
    if (test.test(blob)) return msg;
  }

  const solidityReason = extractSolidityRevertReason(blob);
  if (solidityReason) {
    for (const { test, msg } of REVERT_HINTS) {
      if (test.test(solidityReason)) return msg;
    }
    return `链上拒绝：${solidityReason}`;
  }

  if (/execution reverted/i.test(blob)) {
    return (
      "链上执行被拒绝（execution reverted）。发行请确认：支付币种为已开启的 AAPLB、" +
      "单价与数量有效、已连接 BSC 主网，且钱包有足够 BNB 支付 gas（约 300 万 gas）。"
    );
  }

  if (/Internal JSON-RPC error/i.test(blob)) {
    return formatContractError(
      { message: blob.replace(/Internal JSON-RPC error\.?\s*/i, "") },
      fallback
    );
  }

  const cleaned = blob
    .replace(/^Returned error:\s*/i, "")
    .replace(/^Error:\s*/i, "")
    .trim();
  return cleaned.length > 160 ? `${cleaned.slice(0, 160)}…` : cleaned || fallback;
}
